<div class="integration-card">
  <div class="card-header">
    <img src="assets/icons/aramex/aramex.svg" [alt]="'Aramex' | translate" class="integration-logo" />
    <span *ngIf="(service.status$ | async)?.connected" class="status-badge active">{{ 'Active' | translate }}</span>
  </div>
  <h3 class="integration-title">{{ 'Aramex' | translate }}</h3>
  <p class="integration-description">{{ 'Connect your Aramex account to calculate shipping and prepare deliveries.' |
    translate }}</p>
  <button class="configure-btn" (click)="openPanel.emit()">
    {{ ((service.status$ | async)?.connected ? 'manage' : 'configure') | translate }}
  </button>
</div>

<div class="config-panel" [class.open]="isOpen">
  <div class="panel-header">
    <div class="panel-title">
      <img src="assets/icons/aramex/aramex.svg" [alt]="'Aramex' | translate" class="panel-logo" />
      <div>
        <p>{{ 'Aramex' | translate }}</p>
        <span class="panel-subtitle">{{ 'Configuration' | translate }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="closePanel.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="panel-content">
    <div *ngIf="(service.status$ | async)?.connected" class="status-message success">
      <mat-icon>check_circle</mat-icon>
      <div>
        <strong>{{ 'Integration active' | translate }}</strong>
        <p>{{ 'Your Aramex account is linked.' | translate }}</p>
      </div>
    </div>

    <div class="config-form">
      <div class="form-group">
        <label>{{ 'Account Number' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/account_number.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.accountNumber" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Account PIN' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/account_pin.svg" alt="" class="field-icon" />
          <input type="password" [(ngModel)]="settings.accountPin" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Aramex Username' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/aramex_username.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.username" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Aramex Password' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/aramex_password.svg" alt="" class="field-icon" />
          <input type="password" [(ngModel)]="settings.password" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Account Entity' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/account_entity.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.accountEntity" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Account Country Code' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/world.svg" alt="" class="field-icon" />
          <select class="field-select" required [(ngModel)]="settings.accountCountryCode" name="accountCountryCode">
            <option value="" disabled>{{ 'Select country' | translate }}</option>
            <option *ngFor="let country of countries" [value]="country.isoCode">{{ country.name }}</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Origin Country Code' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/world.svg" alt="" class="field-icon" />
          <select class="field-select" required [(ngModel)]="settings.originCountryCode" name="originCountryCode" (ngModelChange)="onOriginCountryChange()">
            <option value="" disabled>{{ 'Select country' | translate }}</option>
            <option *ngFor="let country of countries" [value]="country.isoCode">{{ country.name }}</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Origin City' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/origin_city.svg" alt="" class="field-icon" />
          <select class="field-select" required [(ngModel)]="settings.originCityName" name="originCityName" [disabled]="!settings.originCountryCode">
            <option value="" disabled>{{ (settings.originCountryCode ? 'Select city' : 'Select origin country first') | translate }}</option>
            <option *ngFor="let city of originCities" [value]="city">{{ city }}</option>
          </select>
        </div>
      </div>

      <div class="form-group" style="display:none">
        <div class="input-with-icon">
          <img src="assets/icons/aramex/origin_city.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.originCityName" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Origin Postal Code' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/postal_code.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.originPostalCode" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Origin Address' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/address.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.originAddressLine" />
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'Origin Phone' | translate }}</label>
        <div class="input-with-icon">
          <img src="assets/icons/aramex/phone.svg" alt="" class="field-icon" />
          <input type="text" [(ngModel)]="settings.originPhone" />
        </div>
      </div>

      <div class="form-group">
        <label class="check-label" (click)="settings.enabled = !settings.enabled">
          <span class="custom-check" [class.checked]="settings.enabled">
            <mat-icon *ngIf="settings.enabled">check</mat-icon>
          </span>
          {{ 'Enable Aramex shipping' | translate }}
        </label>
      </div>
    </div>
  </div>

  <div class="panel-footer">
    <button class="sync-btn" (click)="save()">{{ 'Save Settings' | translate }}</button>
    <button *ngIf="(service.status$ | async)?.connected" class="disconnect-btn" (click)="disconnect()">
      {{ 'Disconnect Integration' | translate }}
    </button>
  </div>
</div>
